export default "d26e004f95e5d5c4.svg"